<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  checkBanco: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:checkBanco']);
const { t } = useI18n();

const documents = [
  { key: 'doc_vendedor', label: t('POST_SALE.FORM.DOC_VENDEDOR') },
  { key: 'doc_comprador', label: t('POST_SALE.FORM.DOC_COMPRADOR') },
  { key: 'doc_imovel', label: t('POST_SALE.FORM.DOC_IMOVEL') },
];

const updateDocument = (key, checked) => {
  emit('update:checkBanco', { ...props.checkBanco, [key]: checked });
};
</script>

<template>
  <fieldset class="grid gap-2">
    <legend class="text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.FORM.DOCUMENTS_CORRECT') }}
    </legend>
    <label
      v-for="document in documents"
      :key="document.key"
      class="flex items-center gap-2 text-sm text-lais-text-body"
    >
      <input
        :checked="Boolean(checkBanco[document.key])"
        type="checkbox"
        @change="updateDocument(document.key, $event.target.checked)"
      />
      <span>{{ document.label }}</span>
    </label>
  </fieldset>
</template>
